// // Add this script AFTER cart.js loads
// // This file should be saved as cart-drawer-webbee-override.js in assets folder

// (function() {
//   'use strict';
  
//   console.log("🛡️ Webbee cart drawer override initializing");
  
//   // Aggressive button control
//   function enforceCheckoutButtonState() {
//     var $ = jQuery;
//     var $checkoutBtn = $('.webbee-side-cart-checkout');
    
//     if ($checkoutBtn.length === 0) return;
    
//     // Check for errors
//     var hasErrors = $('.webbee-error-message-sidecart').length > 0;
    
//     if (hasErrors) {
//       // Multiple ways to disable the button
//       $checkoutBtn.prop('disabled', true);
//       $checkoutBtn.attr('disabled', 'disabled');
//       $checkoutBtn.addClass('webbee-force-disabled');
//       $checkoutBtn.css({
//         'pointer-events': 'none',
//         'opacity': '0.5',
//         'cursor': 'not-allowed'
//       });
      
//       // Prevent form submission
//       $checkoutBtn.off('click.webbee-prevent').on('click.webbee-prevent', function(e) {
//         e.preventDefault();
//         e.stopPropagation();
//         e.stopImmediatePropagation();
//         console.log("🚫 Checkout prevented - inventory errors exist");
//         return false;
//       });
      
//       // Also prevent form submission
//       $checkoutBtn.closest('form').off('submit.webbee-prevent').on('submit.webbee-prevent', function(e) {
//         if ($('.webbee-error-message-sidecart').length > 0) {
//           e.preventDefault();
//           e.stopPropagation();
//           e.stopImmediatePropagation();
//           console.log("🚫 Form submission prevented - inventory errors exist");
//           return false;
//         }
//       });
      
//     } else {
//       // Re-enable button
//       $checkoutBtn.prop('disabled', false);
//       $checkoutBtn.removeAttr('disabled');
//       $checkoutBtn.removeClass('webbee-force-disabled');
//       $checkoutBtn.css({
//         'pointer-events': '',
//         'opacity': '',
//         'cursor': ''
//       });
//       $checkoutBtn.off('click.webbee-prevent');
//       $checkoutBtn.closest('form').off('submit.webbee-prevent');
//     }
//   }
  
//   // Run enforcement continuously
//   setInterval(function() {
//     enforceCheckoutButtonState();
//   }, 100);
  
//   // Also run on any cart update
//   if (typeof jQuery !== 'undefined') {
//     jQuery(document).on('cart:updated', function() {
//       setTimeout(enforceCheckoutButtonState, 100);
//     });
//   }
  
//   // Intercept all clicks on checkout button at capture phase
//   document.addEventListener('click', function(e) {
//     var target = e.target;
    
//     // Check if click is on or within checkout button
//     if (target.matches('.webbee-side-cart-checkout') || 
//         target.closest('.webbee-side-cart-checkout')) {
      
//       if (document.querySelectorAll('.webbee-error-message-sidecart').length > 0) {
//         console.log("🚫 Click intercepted at capture phase - errors exist");
//         e.preventDefault();
//         e.stopPropagation();
//         e.stopImmediatePropagation();
//         return false;
//       }
//     }
//   }, true); // Use capture phase
  
//   console.log("✅ Webbee cart drawer override active");
  
// })();



/**
 * Webbee Cart Drawer Override - Fixed Version
 * Handles inventory validation with proper variant tracking
 */
(function() {
  'use strict';
  
  console.log("🛡️ Webbee cart drawer override initializing (v2.0)");
  
  // Wait for jQuery and global variables
  function waitForDependencies(callback) {
    if (typeof jQuery !== 'undefined' && window.idquantity && window.variantSKUAndInventoryPolicyMap) {
      callback();
    } else {
      setTimeout(() => waitForDependencies(callback), 100);
    }
  }
  
  waitForDependencies(function() {
    const $ = jQuery;
    
    // State management
    let validationInProgress = false;
    let validationQueue = [];
    let lastValidationTime = 0;
    const VALIDATION_DEBOUNCE = 200; // ms
    
    /**
     * Aggregate cart items by SKU and variant ID
     * This solves the duplicate SKU issue
     */
    function aggregateCartItems() {
      const aggregated = new Map();
      
      $('.horizontal-products .horizontal-product').each(function() {
        const $item = $(this);
        const sku = $item.attr('sku');
        const variantId = $item.data('variant-id');
        const key = `${sku}_${variantId}`;
        
        if (!sku || sku === 'undefined') return;
        
        const $qtyInput = $item.find('.webbee-side-cart-quantity');
        const quantity = parseInt($qtyInput.val()) || 0;
        
        if (aggregated.has(key)) {
          // Sum quantities for same variant
          aggregated.get(key).quantity += quantity;
          aggregated.get(key).elements.push($item);
        } else {
          aggregated.set(key, {
            sku: sku,
            variantId: variantId,
            quantity: quantity,
            elements: [$item],
            $qtyInput: $qtyInput
          });
        }
      });
      
      return aggregated;
    }
    
    /**
     * Get available quantity for a SKU
     */
    function getAvailableQuantity(sku) {
      let available = window.idquantity.get(sku);
      
      if (available === 'shopifyqty') {
        available = window.shopifyManagedData.get(sku);
      } else if (window.idquantity.get('zero inventory')) {
        available = 0;
      }
      
      return parseInt(available) || 0;
    }
    
    /**
     * Check if variant allows overselling
     */
    function allowsContinue(sku) {
      const policy = window.variantSKUAndInventoryPolicyMap.get(sku);
      return policy === 'continue';
    }
    
    /**
     * Remove all error messages
     */
    function clearErrorMessages() {
      $('.webbee-error-message-sidecart').remove();
    }
    
    /**
     * Add error message after an item
     */
    function addErrorMessage($item, availableQty) {
      const errorMsg = `<p class='webbee-error-message-sidecart' style='color: red; font-weight: 600; font-size: 13px; margin-top: 5px;'>
        ${window.avaibleQuantity || 'Available quantity is'} ${availableQty}.
      </p>`;
      $item.after(errorMsg);
    }
    
    /**
     * Main validation function
     */
    function validateCartDrawer() {
      if (validationInProgress) {
        console.log("⏳ Validation already in progress, queueing...");
        return;
      }
      
      validationInProgress = true;
      console.log("🔍 validateCartDrawer executing");
      
      // Clear previous errors
      clearErrorMessages();
      
      const $checkoutBtn = $('.webbee-side-cart-checkout');
      let hasErrors = false;
      const errorItems = [];
      
      // Get aggregated items
      const aggregatedItems = aggregateCartItems();
      
      // Validate each unique item
      aggregatedItems.forEach((item, key) => {
        const { sku, quantity, elements } = item;
        
        console.log(`📦 Validating - SKU: ${sku}, Total Qty: ${quantity}`);
        
        // Check if continues are allowed
        if (allowsContinue(sku)) {
          console.log(`✅ Policy: continue - allowing SKU ${sku}`);
          return;
        }
        
        // Get available quantity
        const available = getAvailableQuantity(sku);
        
        console.log(`   Available: ${available}, Requested: ${quantity}`);
        
        // Check if quantity exceeds available
        if (quantity > available) {
          hasErrors = true;
          errorItems.push({ sku, quantity, available, elements });
          
          // Add error message to ALL elements with this SKU
          elements.forEach($el => {
            addErrorMessage($el, available);
          });
          
          console.log(`❌ ERROR: SKU ${sku} - Requested ${quantity} exceeds ${available}`);
        }
      });
      
      // Update button state
      updateCheckoutButton($checkoutBtn, hasErrors);
      
      // Log summary
      if (hasErrors) {
        console.log(`🚫 Validation failed - ${errorItems.length} item(s) with errors`);
        errorItems.forEach(item => {
          console.log(`   - SKU ${item.sku}: ${item.quantity} requested, ${item.available} available`);
        });
      } else {
        console.log("✅ Validation passed - all items valid");
      }
      
      validationInProgress = false;
      window.cartHasErrors = hasErrors;
      
      // Process queue if any
      if (validationQueue.length > 0) {
        console.log(`📋 Processing queued validation (${validationQueue.length} pending)`);
        validationQueue = [];
        setTimeout(validateCartDrawer, 50);
      }
    }
    
    /**
     * Update checkout button state with multiple safeguards
     */
    function updateCheckoutButton($btn, disable) {
      if ($btn.length === 0) return;
      
      if (disable) {
        console.log("🚫 DISABLING checkout button");
        
        // Multiple ways to disable
        $btn.prop('disabled', true);
        $btn.attr('disabled', 'disabled');
        $btn.addClass('webbee-disabled');
        $btn.css({
          'pointer-events': 'none',
          'opacity': '0.5',
          'cursor': 'not-allowed'
        });
        
        // Prevent click events
        $btn.off('click.webbee').on('click.webbee', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          console.log("🚫 Click prevented - cart has errors");
          return false;
        });
        
        // Prevent form submission
        $btn.closest('form').off('submit.webbee').on('submit.webbee', function(e) {
          if (window.cartHasErrors) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            console.log("🚫 Form submission prevented - cart has errors");
            return false;
          }
        });
        
      } else {
        console.log("✅ ENABLING checkout button");
        
        // Remove all restrictions
        $btn.prop('disabled', false);
        $btn.removeAttr('disabled');
        $btn.removeClass('webbee-disabled');
        $btn.css({
          'pointer-events': '',
          'opacity': '',
          'cursor': ''
        });
        
        // Remove event blockers
        $btn.off('click.webbee');
        $btn.closest('form').off('submit.webbee');
      }
    }
    
    /**
     * Debounced validation trigger
     */
    function triggerValidation() {
      const now = Date.now();
      const timeSinceLastValidation = now - lastValidationTime;
      
      if (timeSinceLastValidation < VALIDATION_DEBOUNCE) {
        // Too soon, queue it
        if (validationQueue.length === 0) {
          setTimeout(() => {
            validationQueue = [];
            validateCartDrawer();
          }, VALIDATION_DEBOUNCE - timeSinceLastValidation);
        }
        validationQueue.push(now);
      } else {
        // Execute immediately
        lastValidationTime = now;
        validateCartDrawer();
      }
    }
    
    /**
     * Aggressive button state enforcer
     * Runs continuously to prevent theme from re-enabling button
     */
    function enforceButtonState() {
      if (!window.cartHasErrors) return;
      
      const $btn = $('.webbee-side-cart-checkout');
      if ($btn.length === 0) return;
      
      // If button somehow got enabled, disable it again
      if (!$btn.prop('disabled') || !$btn.attr('disabled')) {
        console.log("⚠️ Button state mismatch detected - re-enforcing");
        updateCheckoutButton($btn, true);
      }
    }
    
    // Run enforcer every 100ms
    setInterval(enforceButtonState, 100);
    
    /**
     * Mutation observer for checkout button changes
     */
    const buttonObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
          if (window.cartHasErrors && !mutation.target.hasAttribute('disabled')) {
            console.log("⚠️ Mutation detected - re-disabling button");
            updateCheckoutButton($(mutation.target), true);
          }
        }
      });
    });
    
    /**
     * Attach observer to checkout button
     */
    function attachCheckoutButtonObserver() {
      const btn = document.querySelector('.webbee-side-cart-checkout');
      if (btn) {
        buttonObserver.observe(btn, {
          attributes: true,
          attributeFilter: ['disabled']
        });
        console.log("✅ Checkout button observer attached");
      }
    }
    
    /**
     * Observer for new buttons being added to DOM
     */
    const cartObserver = new MutationObserver(function(mutations) {
      let shouldReattach = false;
      
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            const $node = $(node);
            if ($node.hasClass('webbee-side-cart-checkout') || 
                $node.find('.webbee-side-cart-checkout').length) {
              shouldReattach = true;
            }
          }
        });
      });
      
      if (shouldReattach) {
        console.log("🆕 New checkout button detected");
        setTimeout(() => {
          attachCheckoutButtonObserver();
          triggerValidation();
        }, 100);
      }
    });
    
    // Start observing cart drawer
    const cartDrawer = document.querySelector('.cart-drawer');
    if (cartDrawer) {
      cartObserver.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
      console.log("✅ Cart drawer observer initialized");
    }
    
    // Initialize
    $(document).ready(function() {
      attachCheckoutButtonObserver();
      
      // Initial validation if drawer is visible
      if ($('.cart-drawer').is(':visible')) {
        triggerValidation();
      }
    });
    
    // ========================================
    // EVENT HANDLERS
    // ========================================
    
    // Quantity button clicks
    $(document).on('click', '.webbee-side-cart-minus, .webbee-side-cart-plus', function() {
      console.log("➕➖ Side cart quantity button clicked");
      setTimeout(triggerValidation, 100);
    });
    
    // Quantity input changes
    $(document).on('input change', '.webbee-side-cart-quantity', function() {
      console.log("⌨️ Side cart quantity input changed");
      triggerValidation();
    });
    
    // Cart drawer opened
    $(document).on('click', '[aria-controls="CartDrawer"]', function() {
      console.log("🛒 Cart drawer opened");
      setTimeout(triggerValidation, 300);
    });
    
    // Product added to cart
    $(document).on('click', '.product-form__submit', function() {
      console.log("🛒 Product added to cart");
      setTimeout(triggerValidation, 500);
    });
    
    // Cart updated event
    $(document).on('cart:updated', function() {
      console.log("🔄 Cart updated event");
      setTimeout(triggerValidation, 200);
    });
    
    // Monitor drawer visibility
    let wasVisible = false;
    setInterval(function() {
      const $drawer = $('.cart-drawer');
      const isVisible = $drawer.is(':visible');
      
      if (isVisible && !wasVisible) {
        console.log("👁️ Cart drawer became visible");
        setTimeout(triggerValidation, 200);
      }
      
      wasVisible = isVisible;
    }, 500);
    
    // Intercept clicks at capture phase
    document.addEventListener('click', function(e) {
      const target = e.target;
      
      if (target.matches('.webbee-side-cart-checkout') || 
          target.closest('.webbee-side-cart-checkout')) {
        
        if (window.cartHasErrors) {
          console.log("🚫 Click intercepted - cart has errors");
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      }
    }, true);
    
    // Expose validation function globally
    window.webbeeValidateCart = triggerValidation;
    
    console.log("✅ Webbee cart drawer override active (v2.0)");
  });
  
})();